// Mock data for Vidya365 Coaching Website

export const courses = {
  ssc: [
    {
      id: 'ssc-cgl',
      name: 'SSC CGL',
      fullName: 'Staff Selection Commission - Combined Graduate Level',
      description: 'Comprehensive coaching for SSC CGL exam with expert faculty and proven strategies',
      duration: '6-12 Months',
      modes: ['Offline', 'Online', 'Test Series'],
      eligibility: 'Graduate',
      icon: 'BookOpen'
    },
    {
      id: 'ssc-chsl',
      name: 'SSC CHSL',
      fullName: 'Combined Higher Secondary Level',
      description: 'Complete preparation for SSC CHSL with focused study material and practice tests',
      duration: '4-8 Months',
      modes: ['Offline', 'Online', 'Test Series'],
      eligibility: '12th Pass',
      icon: 'GraduationCap'
    },
    {
      id: 'ssc-mts',
      name: 'SSC MTS',
      fullName: 'Multi-Tasking Staff',
      description: 'Targeted coaching for SSC MTS examination with regular mock tests',
      duration: '3-6 Months',
      modes: ['Offline', 'Online', 'Test Series'],
      eligibility: '10th Pass',
      icon: 'Award'
    },
    {
      id: 'ssc-cpo',
      name: 'SSC CPO',
      fullName: 'Central Police Organization',
      description: 'Specialized training for SSC CPO including physical and written preparation',
      duration: '6-10 Months',
      modes: ['Offline', 'Online', 'Test Series'],
      eligibility: 'Graduate',
      icon: 'Shield'
    }
  ],
  bank: [
    {
      id: 'ibps-po',
      name: 'IBPS PO',
      fullName: 'Institute of Banking Personnel Selection - Probationary Officer',
      description: 'Expert coaching for IBPS PO with banking awareness and current affairs',
      duration: '6-12 Months',
      modes: ['Offline', 'Online', 'Test Series'],
      eligibility: 'Graduate',
      icon: 'Briefcase'
    },
    {
      id: 'sbi-po',
      name: 'SBI PO',
      fullName: 'State Bank of India - Probationary Officer',
      description: 'Comprehensive SBI PO preparation with interview guidance',
      duration: '6-12 Months',
      modes: ['Offline', 'Online', 'Test Series'],
      eligibility: 'Graduate',
      icon: 'Building2'
    },
    {
      id: 'rrb-po',
      name: 'RRB PO',
      fullName: 'Regional Rural Bank - Probationary Officer',
      description: 'Complete RRB PO coaching with rural banking focus',
      duration: '5-10 Months',
      modes: ['Offline', 'Online', 'Test Series'],
      eligibility: 'Graduate',
      icon: 'Landmark'
    },
    {
      id: 'ibps-clerk',
      name: 'IBPS Clerk',
      fullName: 'Institute of Banking Personnel Selection - Clerk',
      description: 'Focused IBPS Clerk preparation with speed and accuracy training',
      duration: '4-8 Months',
      modes: ['Offline', 'Online', 'Test Series'],
      eligibility: 'Graduate',
      icon: 'FileText'
    },
    {
      id: 'sbi-clerk',
      name: 'SBI Clerk',
      fullName: 'State Bank of India - Clerk',
      description: 'SBI Clerk exam coaching with banking fundamentals',
      duration: '4-8 Months',
      modes: ['Offline', 'Online', 'Test Series'],
      eligibility: 'Graduate',
      icon: 'Wallet'
    },
    {
      id: 'rrb-clerk',
      name: 'RRB Clerk',
      fullName: 'Regional Rural Bank - Clerk',
      description: 'RRB Clerk preparation with comprehensive study material',
      duration: '4-8 Months',
      modes: ['Offline', 'Online', 'Test Series'],
      eligibility: 'Graduate',
      icon: 'CreditCard'
    }
  ],
  rbi: [
    {
      id: 'rbi-grade-b',
      name: 'RBI Grade B',
      fullName: 'Reserve Bank of India - Grade B Officer',
      description: 'Premium coaching for RBI Grade B with economic and financial management focus',
      duration: '8-14 Months',
      modes: ['Offline', 'Online', 'Test Series'],
      eligibility: 'Graduate (50%)',
      icon: 'TrendingUp'
    },
    {
      id: 'rbi-assistant',
      name: 'RBI Assistant',
      fullName: 'Reserve Bank of India - Assistant',
      description: 'Complete RBI Assistant preparation with comprehensive test series',
      duration: '5-10 Months',
      modes: ['Offline', 'Online', 'Test Series'],
      eligibility: 'Graduate',
      icon: 'Users'
    }
  ]
};

export const features = [
  {
    id: 1,
    title: 'Offline Classes',
    description: 'Interactive classroom sessions with experienced faculty, personalized attention, and peer learning environment',
    icon: 'School',
    benefits: ['Face-to-face interaction', 'Doubt clearing sessions', 'Study material provided', 'Regular assessments']
  },
  {
    id: 2,
    title: 'Online Classes',
    description: 'Live and recorded classes accessible from anywhere, flexible timing, and comprehensive digital study resources',
    icon: 'Monitor',
    benefits: ['Learn from anywhere', 'Flexible timings', 'Recorded lectures', 'Digital notes']
  },
  {
    id: 3,
    title: 'Test Series',
    description: 'Extensive mock tests with detailed analysis, performance tracking, and exam pattern simulation',
    icon: 'ClipboardCheck',
    benefits: ['Mock tests', 'Performance analysis', 'All India ranking', 'Previous year papers']
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: 'Expert Faculty',
    description: 'Highly qualified and experienced educators with proven track record',
    icon: 'Users2'
  },
  {
    id: 2,
    title: 'Proven Results',
    description: 'Thousands of successful selections in government exams',
    icon: 'Trophy'
  },
  {
    id: 3,
    title: 'Updated Content',
    description: 'Latest syllabus and exam pattern based study material',
    icon: 'BookMarked'
  },
  {
    id: 4,
    title: 'Personal Mentoring',
    description: 'Individual attention and guidance for every student',
    icon: 'UserCheck'
  },
  {
    id: 5,
    title: 'Affordable Fees',
    description: 'Quality education at competitive and transparent pricing',
    icon: 'IndianRupee'
  },
  {
    id: 6,
    title: 'Study Material',
    description: 'Comprehensive books, notes, and online resources',
    icon: 'Library'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Priya Sharma',
    exam: 'SBI PO 2024',
    image: '',
    text: 'Vidya365 transformed my preparation journey. The faculty support and test series were instrumental in my success.',
    rating: 5
  },
  {
    id: 2,
    name: 'Rahul Kumar',
    exam: 'SSC CGL 2024',
    image: '',
    text: 'Best coaching institute! The online classes were flexible and the study material was comprehensive.',
    rating: 5
  },
  {
    id: 3,
    name: 'Anjali Verma',
    exam: 'RBI Grade B 2024',
    image: '',
    text: 'The expert guidance and personalized mentoring helped me crack RBI Grade B. Thank you Vidya365!',
    rating: 5
  }
];

export const stats = [
  { label: 'Students Enrolled', value: '10,000+', icon: 'Users' },
  { label: 'Success Rate', value: '85%', icon: 'Target' },
  { label: 'Expert Faculty', value: '50+', icon: 'Award' },
  { label: 'Mock Tests', value: '500+', icon: 'FileCheck' }
];
